export default __webpack_public_path__ + "static/media/Vectoric_bell.b1349a9e.svg";